/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apiReceiptPaper",
            "endpoint": "https://5sjfaxoql6.execute-api.ap-northeast-1.amazonaws.com/receiptsrc",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:ceb7e4cb-84fb-47f9-8ee4-6aaa20b0317a",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_l6HipbklW",
    "aws_user_pools_web_client_id": "287an5a36cebarouu0iiisgega",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "receipt_paper-receiptsrc",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "receiptpaper53520-receiptsrc",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
